import { useState } from 'preact/hooks';

export function SupportButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const sessionId = localStorage.getItem('sessionId');
      const res = await fetch('/api/support', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionId}`
        },
        body: JSON.stringify({ subject, message })
      });

      const data = await res.json();

      if (res.ok && data.success) {
        setSuccess(true);
        setSubject('');
        setMessage('');
        // Auto-close after 3 seconds
        setTimeout(() => {
          setIsOpen(false);
          setSuccess(false);
        }, 3000);
      } else {
        setError(data.error || 'Failed to send support request');
      }
    } catch (err) {
      setError('Failed to send support request. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {/* Floating Support Button */}
      <button
        class="support-fab"
        onClick={() => setIsOpen(true)}
        title="Get Help"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </button>

      {/* Support Modal */}
      {isOpen && (
        <div class="modal-overlay" onClick={() => setIsOpen(false)}>
          <div class="modal support-modal" onClick={e => e.stopPropagation()}>
            <div class="modal-header">
              <h2>Contact Support</h2>
              <button class="modal-close" onClick={() => setIsOpen(false)}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            <div class="modal-body">
              {success ? (
                <div class="success-message">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  <h3>Message Sent!</h3>
                  <p>We'll get back to you as soon as possible.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <p class="support-intro">
                    Need help? Send us a message and we'll get back to you shortly at <strong>helpdesk@vanilla.net.mt</strong>
                  </p>

                  {error && (
                    <div class="alert alert-error">{error}</div>
                  )}

                  <div class="form-group">
                    <label for="subject">Subject</label>
                    <input
                      type="text"
                      id="subject"
                      value={subject}
                      onInput={e => setSubject(e.target.value)}
                      placeholder="Brief description of your issue"
                      required
                    />
                  </div>

                  <div class="form-group">
                    <label for="message">Message</label>
                    <textarea
                      id="message"
                      value={message}
                      onInput={e => setMessage(e.target.value)}
                      placeholder="Please describe your issue or question in detail..."
                      rows="5"
                      required
                    />
                  </div>

                  <div class="modal-actions">
                    <button type="button" class="btn btn-secondary" onClick={() => setIsOpen(false)}>
                      Cancel
                    </button>
                    <button type="submit" class="btn btn-primary" disabled={loading}>
                      {loading ? 'Sending...' : 'Send Message'}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      )}

      <style>{`
        .support-fab {
          position: fixed;
          bottom: 24px;
          right: 24px;
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: #4F46E5;
          color: white;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 12px rgba(79, 70, 229, 0.4);
          transition: transform 0.2s, box-shadow 0.2s;
          z-index: 1000;
        }

        .support-fab:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 16px rgba(79, 70, 229, 0.5);
        }

        .support-modal {
          max-width: 480px;
          width: 100%;
        }

        .support-intro {
          color: #6B7280;
          margin-bottom: 1.5rem;
        }

        .support-intro strong {
          color: #4F46E5;
        }

        .success-message {
          text-align: center;
          padding: 2rem 1rem;
        }

        .success-message svg {
          margin-bottom: 1rem;
        }

        .success-message h3 {
          color: #10B981;
          margin-bottom: 0.5rem;
        }

        .success-message p {
          color: #6B7280;
        }
      `}</style>
    </>
  );
}
